// @flow
import { createDomain } from 'effector'
import { unexpectedErrorAlert } from 'utils/error'
import { logger } from '../logger'

export const domain = createDomain('updater')

domain.onCreateEffect((effect) => {
  effect.fail.watch((error) => {
    unexpectedErrorAlert({ error, logger })
  })
})
